/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-01-25 16:42:55
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-15 14:33:19
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Menu/MenuItem/MenuItem/Menu.tsx
 */
import { Menu } from 'antd';
import React from 'react';

const { Item } = Menu;
const MenuItem = (props) => {
  const { children, onClickCommon, onClick, disabled, ...rest } = props;
  return (
    <Item
      disabled={disabled}
      onClick={(...rest) => {
        if (onClickCommon) onClickCommon();
        if (onClick) onClick(...rest);
      }}
      {...rest}>
      {children}
    </Item>
  );
};
export default MenuItem;
